import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8c27d37e&scoped=true"
var script = {}
import style0 from "./index.less?vue&type=style&index=0&id=8c27d37e&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c27d37e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/b08365e4-b55a-4269-82b4-b5e5a1490008/workspace/hsylc_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c27d37e')) {
      api.createRecord('8c27d37e', component.options)
    } else {
      api.reload('8c27d37e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8c27d37e&scoped=true", function () {
      api.rerender('8c27d37e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Poster/LiveReservation/Bpc/index.vue"
export default component.exports